import {
  FundProjectionScreenOutlined,
  UserOutlined,
  UserSwitchOutlined,
  ReconciliationOutlined,
  TagOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import styles from "./index.module.scss";

const MenuSide: React.FC = (props) => {
  const [curKey, setCurKey] = useState<string>();

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.match(/^\/admin\/projects/)) {
      setCurKey("projects");
    } else if (location.pathname.match(/\/admin\/users/)) {
      setCurKey("users");
    } else if (location.pathname.match(/\/admin\/roles/)) {
      setCurKey("roles");
    } else if (location.pathname.match(/\/admin\/users/)) {
      setCurKey("users");
    } else if (location.pathname.match(/\/admin\/whiteList/)) {
      setCurKey("whiteList");
    } else if (location.pathname.match(/\/admin\/tag/)) {
      setCurKey("tag");
    }
  }, [location]);

  return (
    <aside className={styles.menu_side}>
      <Menu
        // onClick={(e) => {}}
        multiple={false}
        onSelect={(e) => {
          setCurKey(e.selectedKeys[0]);

          switch (e.selectedKeys[0]) {
            case "projects":
              navigate("/admin/projects");
              break;
            case "users":
              navigate("/admin/users");
              break;
            case "roles":
              navigate("/admin/roles");
              break;
            case "users":
              navigate("/admin/users");
              break;
            case "whiteList":
              navigate("/admin/whiteList");
              break;
            case "tag":
              navigate("/admin/tag");
              break;
          }
        }}
        selectedKeys={[curKey ?? ""]}
        items={[
          {
            key: "projects",
            icon: <FundProjectionScreenOutlined />,
            label: "我的项目",
          },
          {
            key: "users",
            icon: <UserOutlined />,
            label: "用户管理",
          },
          {
            key: "roles",
            icon: <UserSwitchOutlined />,
            label: "应用分组",
          },
          {
            key: "whiteList",
            icon: <ReconciliationOutlined />,
            label: "白名单管理",
          },
          {
            key: "tag",
            icon: <TagOutlined />,
            label: "标签管理",
          },
        ]}
      />
    </aside>
  );
};

export default MenuSide;
